import { Toggle } from "tailwindcss-stimulus-components"

// Connects to data-controller="conditional-toggle"
export default class extends Toggle {
  static targets = ["toggleable", "toggleableOption", "disallowedOption"]

  show() {
    if (this.noDisallowedOptionSelected()) {
      super.show()
      this.toggleableOptionTargets.forEach(target => {
        target.disabled = false
      })
    }
  }

  hide() {
    this.toggleableOptionTargets.forEach(target => {
      target.disabled = true
    });
    super.hide()
  }

  // Private

  noDisallowedOptionSelected() {
    return !this.disallowedOptionTargets.some((target) => {
      return target.checked
    })
  }
}
